module.exports = __webpack_public_path__ + "img/MHI Vestas.ffb0a264.jpg";